import React, { useCallback, useMemo } from 'react'
import { Image, ImageProps } from 'Components/view-image'

const CenterImageWrap: React.FC<ImageProps & {
  wrapClassName: string
  duration: string
}> = ({
  ...props
}) => {

    return (
      <div className={`center-image-wrap g-load-img-wrap g-load-small-img-wrap ${props.wrapClassName}`}>
        <Image {...props} />
        {props.duration && <p className="duration"><span>{props.duration}</span></p>}
        <style jsx>
          {`
          .center-image-wrap {
            position: relative;
            width: ${props.width / 2}px;
            height: ${props.height / 2}px;
            overflow: hidden;
            border-radius: 2px;
          }
          .duration{
            position: absolute;
            right: 4px;
            bottom: 4px;
            width: 49px;
            height: 20px;
            padding: 4px 6px 4px 4px;
            border-radius: 15px;
            background-color: rgba(0, 0, 0, 0.8);
            padding-bottom: 4px;
          }
          .duration span{
            position:absolute;
            top: 1px;
            right: 4px;
            color: #fff;
            font-size: 12px;
            transform: scale(0.83);
          }
          .duration span:before{
            content:'';
            display: inline-block;
            width: 0;
            height: 0;
            margin-right: 5px;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #fff;
          }
          :global(.center-image-wrap img){
            position: absolute;
            left: 50%;
            top: 50%;
            width: 100%;
            transform: translate(-50%, -50%);
          }
        `}
        </style>
      </div>
    )
  }

export default CenterImageWrap;
